
import { motion } from 'framer-motion';
import './Projects.css';
import flat12 from '../assets/Residential/Apartment/flat12.png';
import com1 from '../assets/Resort/1 (1).JPG';
import ind1 from '../assets/industrial/ind1.jpg';


const Projects = () => {
  const categories = [
    { id: 'residential', name: 'RESIDENTIAL' },
    { id: 'industrial', name: 'INDUSTRIAL' },
   
  ];

  const projects = [
    {
      id: 1,
      title: 'Luxury Flat',
      category: 'residential',
      location: 'Hitrch City',
      area: '7,000 sft.',
      description: 'Luxury Apartment ',
      image:flat12 
    },
   
    {
      id: 2,
      title: 'Seed Processing Unit',
      category: 'industrial',
      location: 'Dabilpur,Hyderabad',
      area: '3,500 sq ft',
      description: 'Seeding processing unit built for industrial purpose.',
      image: ind1
    }
  ];

  const featuredProject = {
    title: 'Resort Convention',
    description: 'Resort with aesthic design placed in shamshabad.',
    location: 'Shamshabad,Hyderabad',
    image: com1
  };

  return (
    <section id="projects" className="section projects">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>Projects</h2>
        </motion.div>

        <div className="projects-layout">
          <motion.div 
            className="project-categories"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {categories.map(category => (
              <motion.div 
                key={category.id} 
                className="category-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <h3>{category.name}</h3>
                <div className="category-image">
                  <img 
                    src={projects.find(p => p.category === category.id)?.image || ''} 
                    alt={category.name} 
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>

          <motion.div 
            className="featured-project"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="featured-image">
              <img src={featuredProject.image} alt={featuredProject.title} />
            </div>
            <div className="featured-content">
              <h3>Commercial</h3>
              <p className="featured-description">{featuredProject.description}</p>
              <h4 className="featured-title">{featuredProject.title}</h4>
              <p className="featured-location">{featuredProject.location}</p>
              
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Projects; 